export var randomString = (length) => {
    var result = [];
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result.push(characters.charAt(Math.floor(Math.random() *
            charactersLength)));
    }
    return result.join('');
}

export var randomNumber = (max) => {
    return Math.random() * (max - 0) + 0;
}



// WEBPACK FOOTER //
// ./src/app/shared/generateRandom.ts